//@flow
import React from "react";

export default function scorePill(scorePoints: number) {
  const scoreMap = [
    { label: "E", bkgColor: "danger", textColor: "white" }, // 0 E
    { label: "E", bkgColor: "danger", textColor: "white" }, // 1 E
    { label: "D", bkgColor: "risk-very-high", textColor: "white" }, // 2 D
    { label: "C", bkgColor: "pumpkin-orange", textColor: "black" }, // 3 C
    { label: "B", bkgColor: "risk-very-low", textColor: "black" }, // 4 B
    { label: "A", bkgColor: "risk-low", textColor: "white" }, // 5 A
  ];

  return (
    <div
      title={scoreMap[scorePoints].label}
      className={`round-badge text-color-${scoreMap[scorePoints].textColor} background-color-${scoreMap[scorePoints].bkgColor}`}
    >
      {scoreMap[scorePoints].label || scorePoints}
    </div>
  );
}
